export default "__VITE_PUBLIC_ASSET__04889c6e__"